import alert_mixin from "@/utils/mixins/alert_mixin";
import { 
  UPLOAD_MEETING_MINUTES, 
  LIST_MEETING_MINUTES, 
  get_headers,  
  get_user_role 
} from "@/utils/constants/constants.js";
import axios from 'axios';

export default {
  name: "UploadMeetingMinutes",
  mixins: [alert_mixin],
  props: {
    lead_id: { type: [Number, String], required: true }
  },
  data: () => ({
    preview_url: null,
    is_previewable: false,
    selected_files: [],
    comments: "",
    meeting_date: "",
    upload_loading: false,
    headers: get_headers(),
    meetings: [],
    user_role: null,
  }),
   mounted() {
    this.user_role = get_user_role();
    if (!this.lead_id) return;
    this.fetch_meetings();
  },
  watch: { 
    lead_id(newVal) { newVal ? this.fetch_meetings() : this.meetings = []; } 
  },
  methods: {
    handle_file_selection(evt) {
      this.selected_files = Array.from(evt.target.files);

      if (this.selected_files.length === 1) {
        this.handle_file_preview(this.selected_files[0]);
      } else {
        this.preview_url = null;
        this.is_previewable = false;
      }
    },

    handle_file_preview(file) {
      const ext = file.name.split(".").pop().toLowerCase();
      this.is_previewable = ["pdf", "jpg", "jpeg", "png"].includes(ext);
      this.preview_url = URL.createObjectURL(file);
    },

    clear_file_selection() {
      if (this.preview_url) URL.revokeObjectURL(this.preview_url);
      this.preview_url = null;
      this.is_previewable = false;
      this.selected_files = [];
    },

    async upload_template() {
      if (!this.selected_files.length || !this.lead_id) {
        return this.show_error(
          "Please select file(s) and make sure a lead is specified."
        );
      }

      const form_data = new FormData();
      form_data.append("lead_id", this.lead_id);
      form_data.append("comments", this.comments);
      form_data.append("meeting_date", this.meeting_date);

      this.selected_files.forEach((file) =>
        form_data.append("minutes_file", file)
      );

      this.upload_loading = true;
      try {
        const { data } = await axios.post(UPLOAD_MEETING_MINUTES, form_data, { 
          headers: { 
            ...this.headers, 
            'Content-Type': 'multipart/form-data' 
          } 
        });

        if (data.status === "success") {
          this.show_success(
            `Uploaded ${this.selected_files.length} file(s) successfully.`
          );
          this.clear_file_selection();
          this.comments = "";
          this.meeting_date = "";
          await this.fetch_meetings();
        } else {
          this.show_error(data.message || "Upload failed");
        }
      } catch (err) {
        const msg =
          err.response?.data?.message ||
          err.response?.data?.detail ||
          err.message;
        this.show_error(msg);
      } finally {
        this.upload_loading = false;
      }
    },

    async fetch_meetings() {
      if (!this.lead_id) return;
      
      try {
        const response = await axios.get(LIST_MEETING_MINUTES, {
          params: { lead_id: this.lead_id },
          headers: this.headers,
        });
        const { data } = response;
        if (data.status === "success") {
          this.meetings = data.data;
        } else {
          this.show_error(data.message || "Could not fetch meetings");
        }
      } catch (err) {
        this.show_error("Fetch error: " + err.message);
      }
    },

    format_date(value) {
      if (!value) return "";
      return new Date(value).toLocaleString();
    } 
  },

  beforeDestroy() {
    this.clear_file_selection();
  },
};